export default __webpack_public_path__ + "static/simple-bubble-27f9628a635fd55e2fbc8d96607dd16e.png";